const AUTH_ROUTES = Object.freeze({
	root: {
		name: 'Auth',
		path: '/auth',
		meta: {
			layout: 'Auth',
		},
		redirect: {
			name: 'Login',
		},
		component: () => import('@/presentation/modules/auth/views/RootView.vue'),
	},
	login: {
		name: 'Login',
		path: 'login',
		component: () => import('@/presentation/modules/auth/views/LoginView.vue'),
	},
	otp: {
		name: 'Otp',
		path: 'otp',
		component: () => import('@/presentation/modules/auth/views/OtpView.vue'),
	},
	signup: {
		name: 'Signup',
		path: 'signup',
		component: () => import('@/presentation/modules/auth/views/SignupView.vue'),
	},
	adminLogin: {
		name: 'AdminLogin',
		path: 'admin-login',
		component: () => import('@/presentation/modules/auth/views/AdminLoginView.vue'),
	},
	adminOtp: {
		name: 'AdminOtp',
		path: 'admin-otp',
		component: () => import('@/presentation/modules/auth/views/AdminOtpView.vue'),
	},
});

export default AUTH_ROUTES;
